/**
 * This is the theme module of the application, It contain the application theme related dependencies
 */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import { HeaderComponent } from '@theme/components/layout/header/header.component';
import { FooterComponent } from '@theme/components/layout/footer/footer.component';
import { LayoutComponent } from '@theme/components/layout/layout/layout.component';
import { MaterialComponentsModule } from '@theme/material-components.module';
import { ReactiveFormsModule } from '@angular/forms';
import { SideBarComponentComponent } from './components/layout/side-bar/side-bar-component.component';
import { RouterModule, Routes } from '@angular/router';
import { MasterComponent } from '../pages/components/master/master.component';
import { NotFoundComponent } from './components/http-error/not-found/not-found.component';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { PipeModule } from '@app/core/pipes/pipe.module';
// import { ChartsModule } from 'ng2-charts';

let route: Routes = [
  {
    path: '', component: MasterComponent, children: [
      {
        path: 'sidebar',
        component: SideBarComponentComponent,
        data: { title: 'sidebar' }
      },
      {
        path: 'not-found',
        component: NotFoundComponent,
        data: { title: 'not-found' }
      }
    ]
  }
];

const components = [
  HeaderComponent,
  FooterComponent,
  LayoutComponent,
  SideBarComponentComponent,
  NotFoundComponent
];

@NgModule({
  declarations: [...components],
  imports: [
    CommonModule,
    SharedModule,
    MaterialComponentsModule,
    ReactiveFormsModule,
    NgScrollbarModule,
    // ChartsModule,
    RouterModule.forChild(route),
    PipeModule
  ],
  exports: [
    SharedModule,
    MaterialComponentsModule,
    ...components,
    ReactiveFormsModule
  ]
})
export class AppThemeModule { }
